import { Injectable } from '@angular/core';
import { Action, createSelector, NgxsOnInit, Selector, State, StateContext, Store } from '@ngxs/store';
import { ColumnStateModel } from 'ng2-app/models/businesses/GridColumnDef.model';
import { ColumnDataService } from 'ng2-app/services/column-data/column-data.service';
import { InitColumns, UpdateColumnData } from 'ng2-app/store/column-data/column-data.actions';

@State<ColumnStateModel>({
    name: 'columnData',
    defaults: {
        columns: []
    }
})
@Injectable()

export class ColumnDataState implements NgxsOnInit {

    @Selector()
    static columns(state: ColumnStateModel) {
        return state.columns;
    }

    @Selector()
    static getColumnsByPath(path: string) {
        return createSelector([ColumnDataState], (state: ColumnStateModel) => state['columnData'].columns.find(s => s.path === path));
    }

    constructor(
        private _columnDataService: ColumnDataService,
        private store: Store
    ) {}

    ngxsOnInit(ctx: StateContext<ColumnDataState>) {
        ctx.dispatch(new InitColumns(window.location.pathname));
    }

    @Action(InitColumns)
    initColumns({getState}: StateContext<ColumnStateModel>, { path }: InitColumns) {
        const curColumnDataByPath = getState().columns.find(s => s.path === path);
        if(!curColumnDataByPath) {
            const storedColumnData = this._columnDataService.getColumnDataByPath(path);
            if(storedColumnData) {
                this.store.dispatch(new UpdateColumnData(storedColumnData));
            }
        }
    }

    @Action(UpdateColumnData)
    updateColumnStore({ getState, patchState }: StateContext<ColumnStateModel>, { list }: UpdateColumnData) {
        const currentColumns = getState().columns;
        const currentColumnIndex = currentColumns.findIndex((x: { path: string }) => x.path === list.path);
        const columns = [
            ...currentColumns.slice(0, currentColumnIndex),
            list,
            ...currentColumns.slice(currentColumnIndex + 1),
        ];
        patchState({ columns });

        this._columnDataService.setColumnData(columns);
        return list;
    }
}
